(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('PermissionsCtrl', ['$scope', 'Utils', function ($scope, Utils) {
    $scope.$on("permission-saved", function (evt, persona, index) {
      $scope.permissions[index] = persona;
    });
    $scope.$on("permission-deleted", function (evt, index) {
      $scope.permissions = Utils.removeAt($scope.permissions, index);
    });
  }]).controller('AdministratorPermissionsCtrl', ['$scope', '$q', '$routeParams', '$location', '$http', 'Api', 'Utils', function ($scope, $q, $routeParams, $location, $http, Api, Utils) {
    function createPermission(m, type) {
      return {
        person: {
          name: m.user.name,
          created: m.user.created,
          membership: m,
          type: {
            name: type
          },
          email: m.user.email,
          userId: m.user.id
        },
        target: $scope.entity,
        access: "All"
      };
    }
    $scope.loadOrganizationalMembers = $q.all([$http.get(Api.url("/memberships"), {
      params: {
        role: "admin"
      }
    }), $http.get($scope.targetingPermissionsApiUrl)]).then(function (responses) {
      $scope.administratorPermissions = _.sortBy(_.map(responses[0].data.results, _.partial(createPermission, _, 'Administrator')), function (p) {
        return p.person.name;
      });

      // Don't re-show admins and owners in this group.  If they have explicit targeting permissions, filter them from this list
      var targetingPermissions = responses[1].data;
      $scope.administratorPermissions = _.filter($scope.administratorPermissions, function (permission) {
        return !_.find(targetingPermissions, function (targetPermission) {
          // Using name because we're comparing users and people here so ID's don't map.  Admins
          // and owners will be few enough that this should't be an issue.
          return permission.person && targetPermission.person && permission.person.name === targetPermission.person.name;
        });
      });
    });
    $scope.openPersonPage = function (person) {
      $http.get(Api.url("/people/with-persona"), {
        params: {
          persona: {
            mbox: "mailto:" + person.email
          }
        }
      }).then(function (response) {
        $location.path("/settings/people/" + response.data.id);
      }, function () {
        $http.post(Api.url("/people"), {
          name: person.name,
          personas: [{
            name: person.name,
            mbox: "mailto:" + person.email
          }]
        }).then(function (response) {
          $location.path("/settings/people/" + Utils.getIdFromCreatedResponse(response));
        });
      });
    };
  }]).controller('YourGroupPermissionsCtrl', ['$scope', '$controller', 'Utils', function ($scope, $controller, Utils) {
    $scope.defaultSortBy = "target.name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "target.name",
        "Descending": "-target.name"
      },
      "colspan": 2
    }, {
      "title": "Type",
      "options": {
        "Ascending": "target.type.name",
        "Descending": "-target.type.name"
      },
      "class": "col-md-2"
    }, {
      "title": "Owner"
    }, {
      "title": ""
    }];
    $scope.apiUrl = Utils.appendParams($scope.permissionsApiUrl, {
      "is_null": "targetFilter"
    });
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.name;
    };
    $scope.addPermission = function () {
      $scope.$broadcast('item-added', {
        isNew: true,
        access: $scope.access,
        group: $scope.groupId ? $scope.entity : undefined,
        person: $scope.personId ? $scope.entity : undefined
      });
    };
    $scope.defaultSearchBy = "target.name";
    $scope.searchPlaceholder = "Search";
    $scope.pageSize = 10;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('YourFilterPermissionsCtrl', ['$scope', '$controller', 'Utils', function ($scope, $controller, Utils) {
    $scope.defaultSortBy = "target.name";
    $scope.sortControls = [{
      "title": "Filter"
    }, {
      "title": "Owner"
    }, {
      "title": ""
    }];
    $scope.apiUrl = Utils.appendParams($scope.permissionsApiUrl, {
      "is_not_null": "targetFilter"
    });
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.name;
    };
    $scope.addPermission = function () {
      $scope.$broadcast('item-added', {
        isNew: true,
        access: $scope.access,
        group: $scope.groupId ? $scope.entity : undefined,
        person: $scope.personId ? $scope.entity : undefined
      });
    };
    $scope.defaultSearchBy = "target.name";
    $scope.searchPlaceholder = "Search";
    $scope.pageSize = 10;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('TargetingPermissionsCtrl', ['$scope', '$controller', function ($scope, $controller) {
    $scope.defaultSortBy = "group.name,person.name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "group.name,person.name",
        "Descending": "-group.name,-person.name"
      },
      "colspan": 2
    }, {
      "title": "Type",
      "class": "col-md-2"
    }];
    $scope.apiUrl = $scope.targetingPermissionsApiUrl;
    $scope.formatSearchSuggestion = function formatSearchSuggestion(result) {
      return result.name;
    };
    $scope.defaultSearchBy = "name";
    $scope.searchPlaceholder = "Search";
    $scope.pageSize = 10;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
  }]).controller('GroupPermissionItemCtrl', ['$scope', '$controller', '$http', 'Api', 'Logger', 'Utils', 'Validation', 'wsConstants', function ($scope, $controller, $http, Api, Logger, Utils, Validation, wsConstants) {
    $scope.globalGroup = {
      "id": -1,
      "name": "All"
    };

    //define select function for ws-people-groups-search directive
    $scope.select = function (item) {
      $scope.permission.target = item;
    };
    function validateForm() {
      return Validation.validate({
        "target": {
          "rules": {
            "required": true
          },
          "value": $scope.permission.target
        }
      });
    }
    function resetEditingState() {
      $scope.editing = false;
      $scope.formErrors = null;
      $scope.ownedByEntity = $scope.personId && $scope.permission.person && parseInt($scope.personId) === $scope.permission.person.id || $scope.groupId && $scope.permission.group && parseInt($scope.groupId) === $scope.permission.group.id;
      if ($scope.permission.id && !$scope.permission.target) {
        $scope.permission.target = {
          "name": wsConstants.allGroup.name
        };
      }
    }
    resetEditingState();
    if (!$scope.permission.id) {
      $scope.editing = true;
    }
    $scope.save = function save() {
      $scope.formErrors = validateForm();
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $scope.serverError = null;
      if ($scope.permission.target.id === $scope.globalGroup.id) {
        $scope.permission.target = null;
        $scope.permission.global = true;
      }
      var saveFunction = $scope.permission.id ? _.partial($http.put, Api.url("/group-permissions/" + $scope.permission.id)) : _.partial($http.post, Api.url("/group-permissions/"));
      saveFunction($scope.permission).then(function (response) {
        var perm = $scope.permission;
        if (!perm.id) {
          perm.id = Utils.getIdFromCreatedResponse(response);
        }
        resetEditingState();
        $scope.$emit("permission-saved", perm, $scope.$index);
      }, function (response) {
        if (response.status === 409) {
          $scope.saveError = "Sorry, the permission for this target and person or group already exists.";
        } else {
          $scope.saveError = "There was an error updating the permission.";
        }
        Logger.error("Update permission failed with response status " + response.status);
        $scope.saving = false;
      });
    };
    $scope.cancel = function cancel() {
      // If it was a new (never saved) pipe and you cancel, remove the row from the UI
      if (!$scope.permission.id) {
        $scope.$emit("item-delete", $scope.$index);
      }
      resetEditingState();
    };
    $scope.remove = function remove() {
      $scope.saveError = null;
      $http['delete'](Api.url("/group-permissions/" + $scope.permission.id)).then(function () {
        $scope.$emit("item-delete", $scope.$index);
      }, function (response) {
        Logger.error("An error occurred deleting permission with id " + $scope.permission.id + "." + "Failed with status " + response.status);
        $scope.saveError = "There was error in deleting the permission.";
      });
    };
  }]).controller('FilterPermissionItemCtrl', ['$scope', '$controller', '$http', 'Api', 'Logger', 'Utils', 'Validation', function ($scope, $controller, $http, Api, Logger, Utils, Validation) {
    function validateForm() {
      return Validation.validate({
        "targetFilter": {
          "rules": {
            "required": true
          },
          "value": $scope.permission.targetFilter
        }
      });
    }
    function resetEditingState() {
      $scope.editing = false;
      $scope.permission = $scope.savedPermission;
      $scope.formErrors = null;
      $scope.ownedByEntity = $scope.personId && $scope.permission.person && parseInt($scope.personId) === $scope.permission.person.id || $scope.groupId && $scope.permission.group && parseInt($scope.groupId) === $scope.permission.group.id;
    }
    $scope.savedPermission = angular.copy($scope.permission);
    resetEditingState();
    if (!$scope.permission.id) {
      $scope.editing = true;
    }
    $scope.save = function save() {
      $scope.formErrors = validateForm();
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $scope.serverError = null;
      var saveFunction = $scope.permission.id ? _.partial($http.put, Api.url("/group-permissions/" + $scope.permission.id)) : _.partial($http.post, Api.url("/group-permissions/"));
      saveFunction($scope.permission).then(function (response) {
        var perm = $scope.permission;
        if (!perm.id) {
          perm.id = Utils.getIdFromCreatedResponse(response);
        }
        $scope.savedPermission = angular.copy($scope.permission);
        resetEditingState();
        $scope.$emit("permission-saved", perm, $scope.$index);
      }, function (response) {
        if (response.status === 409) {
          $scope.saveError = "Sorry, the permission for this target and person or group already exists.";
        } else {
          $scope.saveError = "There was an error updating the permission.";
          var errMsg = response.data && response.data.message;
          if (response.status === 400 && errMsg && errMsg.indexOf("Unrecognized property") === 0) {
            $scope.saveError += " " + errMsg.substring(0, errMsg.indexOf(" Known properties"));
          }
        }
        Logger.error("Update permission failed with response status " + response.status);
        $scope.saving = false;
      });
    };
    $scope.cancel = function cancel() {
      // If it was a new (never saved) pipe and you cancel, remove the row from the UI
      if (!$scope.permission.id) {
        $scope.$emit("item-delete", $scope.$index);
      }
      resetEditingState();
    };
    $scope.edit = function () {
      $scope.editing = true;
      $scope.editor.setValue(angular.toJson($scope.permission.targetFilter, 2) || "{}", -1);
    };
    $scope.remove = function remove() {
      $scope.saveError = null;
      $http['delete'](Api.url("/group-permissions/" + $scope.permission.id)).then(function () {
        $scope.$emit("item-delete", $scope.$index);
      }, function (response) {
        Logger.error("An error occurred deleting permission with id " + $scope.permission.id + "." + "Failed with status " + response.status);
        $scope.saveError = "There was error in deleting the permission.";
      });
    };

    // -------------------------------
    // Advanced Editor (ACE)
    // -------------------------------

    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
      if ($scope.permission && !$scope.permission.targetFilter) {
        _editor.setValue("{}");
      }
    };
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      try {
        $scope.permission.targetFilter = JSON.parse($scope.editor.getValue());
      } catch (error) {
        if (error.name === 'SyntaxError') {
          $scope.saveEnabled = false;
          return;
        }
        throw error;
      }
    }), 500);
  }]);
})();
